<template>
<div class="accordion" role="tablist">
    <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.collapse-1 @click="expanded = !expanded" variant="info">
                <span v-if="!expanded">Ver Líneas</span>
                <span v-else>Ocultar Líneas</span>
            </b-button>
        </b-card-header>
        <b-collapse id="collapse-1" class="mt-2">
            <div class="lines_container">
                <b-form-row>
                    <b-col cols="3">
                        <span class="bold">Producto</span>
                    </b-col>
                    <b-col cols="5">
                        <span class="bold">Descripción</span>
                    </b-col>
                    <b-col cols="2">
                        <span class="bold">Cantidad</span>
                    </b-col>
                    <b-col cols="2">
                        <span class="bold">Precio</span>
                    </b-col>
                </b-form-row>
            </div>
            <div v-for="(item,index) in items" :key="index" no-body class="mb-1 lines_container">
                <b-form-row>
                    <b-col cols="3">
                        <div v-if="item.variant">
                            {{item.itemno + '[' + item.variant + '] '}}
                        </div>
                        <div v-else>{{item.itemno + ' '}}</div>
                        
                        <div v-if="(item.acabadoH || item.acabadoV || item.acabadoF) ">
                            {{'('}} 
                                <span v-if="item.acabadoH">{{item.acabadoH}}</span>
                                <span v-if="item.acabadoV">{{' ' + item.acabadoV}}</span>
                                <span v-if="item.acabadoF">{{' ' + item.acabadoF}}</span>
                            {{')'}}
                        </div>
                    </b-col>
                    <b-col cols="5">
                        {{item.description}}
                    </b-col>
                    <b-col cols="2">
                        {{item.qty}}
                    </b-col>
                    <b-col cols="2">
                        {{parseFloat(item.lineamount).toFixed(2) + " €"}}
                    </b-col>
                    
                </b-form-row>
            </div>  
        </b-collapse>
    </b-card>
</div>
</template>

<script>
export default {
    name: 'Lines',
    data () {
        return {           
            expanded : false,
        }
    },
    computed: {
        items() {
            return this.$store.state.items.filter(itm =>  itm.itemno != null)
        }
    },
}
</script>

<style scoped>
.bold{
    font-weight: bold;
}
.lines_container{
    font-size: small;
}
.lines_container:nth-child(odd) {
  background-color: rgb(176, 216, 228);
}
</style>